import { render } from "./HomeSkillBuilding.vue?vue&type=template&id=df3fcc8a&scoped=true"
import script from "./HomeSkillBuilding.vue?vue&type=script&lang=js"
export * from "./HomeSkillBuilding.vue?vue&type=script&lang=js"

import "./HomeSkillBuilding.vue?vue&type=style&index=0&id=df3fcc8a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2026_previous\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df3fcc8a"]])

export default __exports__